import {
  type ReactNode
} from 'react';

import {
  BRAND_GRADIENT,
  BRAND_GRADIENT_DARK_GLASS
} from '@repo/brand';

import {
  FORM_SUBMIT_BUTTON_CLASSES
} from './form';

interface PrimaryButtonProps {
  children: ReactNode
  loading?: boolean
  disabled?: boolean
  type?: 'submit' | 'button' | 'reset'
  onClick?: () => void
  className?: string
}

// Same button as marketing's FormSubmitButton (./form-submit-button.tsx) - shares its classes
// constant and gradient/spinner treatment - but keeps a simpler loading/disabled API instead of
// FormSubmitButton's submitting/submittingLabel pair, since every auth/dashboard/portal call site
// already builds its own loading-state label as `children` rather than a separate prop.
export function PrimaryButton({
  children, loading, disabled, type = 'submit', onClick, className = ''
}: PrimaryButtonProps) {

  return (
    <button
      type={type}
      disabled={loading || disabled}
      onClick={onClick}
      className={`${ FORM_SUBMIT_BUTTON_CLASSES } ${ BRAND_GRADIENT_DARK_GLASS } ${ className }`}
      style={{
        background: BRAND_GRADIENT
      }}
    >
      {loading && (
        <span className="w-3 h-3 rounded-full border-2 border-white border-b-transparent animate-spin" />
      )}
      {children}
    </button>
  );
}

interface GhostButtonProps {
  children: ReactNode
  onClick?: () => void
  disabled?: boolean
  className?: string
}

export function GhostButton({
  children, onClick, disabled, className = ''
}: GhostButtonProps) {

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`text-sm font-medium underline underline-offset-4 cursor-pointer disabled:cursor-not-allowed disabled:opacity-70 hover:opacity-80 transition-opacity ${ className }`}
      style={{
        color: 'rgba(1,158,250,1)'
      }}
    >
      {children}
    </button>
  );
}
